import * as React from "react";
import {useState} from "react";
import {FIELD_NAMES} from "profile/enums";
import SearchInput from "myshubhlife-component/searchInput";
import {getCompanyInfo} from "IncompleteInfoV2/WorkDetails/api";
import "./style.scss";
import {IWorkDetailsFields} from "IncompleteInfoV2/WorkDetails/index";

export interface IEmployerDetails {
    currentEmployer: string;
    workCin: string;
}
interface IProps {
    workDetails: IWorkDetailsFields;
    isAndroid: boolean;
    onChange?: (employerDetails: IEmployerDetails) => void;
    errors?: string;
}

export const EmployerName = (props: IProps) => {
    const [companyList, updateCompanyList] = useState([]);
    const [selectedEmployer, setSelectedEmployer] = useState({
        currentEmployer: props.workDetails.currentEmployer,
        workCin: props.workDetails.workCin,
    });
    const [showSearchInput, setShowSearchInput] = useState(false);
    const handleOnChange = (value) => {
        let updated = false;
        if (value.length >= 3) {
            getCompanyInfo(value.replace("&", "%26").replace("`", "%60")).then((res) => {
                updateCompanyList(res.data.hits.hit);
                res.data.hits.hit.map((item) => {
                    if (item.fields.name === value) {
                        setSelectedEmployer({
                            currentEmployer: value,
                            workCin: item.fields.cin,
                        });
                        updated = true;
                    } else if (item.fields.name === value.trim()) {
                        setSelectedEmployer({
                            currentEmployer: value.trim(),
                            workCin: item.fields.cin,
                        });
                        updated = true;
                    }
                });
            });
        }
        if (!updated) {
            setSelectedEmployer({
                workCin: null,
                currentEmployer: value,
            });
        }
    };
    const handleOnSelect = (name, value) => {
        props.onChange({currentEmployer: name, workCin: value});
        setShowSearchInput(false);
        updateCompanyList([]);
    };
    const renderEmployer = () => {
        const options = companyList.map((item) => {
            return {
                name: item.fields.name,
                value: item.fields.cin,
            };
        });
        return (
            <div className="employer-search-container">
                <label className="label">Company name</label>
                <div className="employer-name"
                     onClick={() => setShowSearchInput(true)}
                >
                    {props.workDetails.currentEmployer ? props.workDetails.currentEmployer : "Please enter company name"}
                </div>
                <div className="error-message">
                    {props.errors ? props.errors : null}
                </div>
                {
                    showSearchInput &&
                    <SearchInput
                        onChange={handleOnChange}
                        isAndroid={props.isAndroid}
                        onClose={() => setShowSearchInput(false)}
                        onSelect={handleOnSelect}
                        value={selectedEmployer.currentEmployer}
                        fieldName={FIELD_NAMES.CURRENT_EMPLOYER}
                        list={options}
                        showSearchInput={showSearchInput}
                        placeholder={"Please enter company name"}
                        label={"Company name"}
                    />
                }
            </div>
        );
    };
    return renderEmployer();
};
